import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CertificatesService {
  serverUrl: String = environment.serverUrl;
  constructor(private httpClient: HttpClient) { }

  getCertificate() {
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-type': 'application/json' })
    };
    return this.httpClient.get(this.serverUrl + 'cert/certificate');
  }
  loadCertificate(id:any,file: any) {
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-type': 'application/json' })
    };
    return this.httpClient.post(this.serverUrl + 'cert/certificateUpload', {data:file,org_id:id}, httpOptions)
  }
}
